import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SchedaCoopTrasportoFormService } from './scheda-coop-trasporto-form.service';
import { CoopTrasportoFormStoreValidators } from './validators/coop-trasporto.field-validators';

@NgModule({
    declarations: [],
    imports: [CommonModule, ReactiveFormsModule],
    providers: [SchedaCoopTrasportoFormService, CoopTrasportoFormStoreValidators],
})
export class SchedaCoopTrasportoFormModule {}
